/**
 * 共通処理
 *
 * No.    日付          更新者    更新内容
 *   1    2021/04/20            新規作成
 *
 * @summary ユーティリティーフォーム関連
 * @copyright 2021, WINGSYSTEMS K.K.
 */
'use strict';

//import 'jquery';
import 'bootstrap';
//import '../../../node_modules/@popperjs/core/dist/esm/popper';
//import '../../../node_modules/bootstrap/dist/js/bootstrap';
//import '../../../node_modules/@popperjs/core/dist/cjs/popper';  // eslint-disable-line no-unused-vars
//import { Tooltip, Toast, Popover } from '../../../node_modules/bootstrap/dist/js/bootstrap';  // eslint-disable-line no-unused-vars
//import './_fin.js';
//import { Tooltip, Toast, Popover } from '../../../node_modules/bootstrap/dist/js/bootstrap';
// Bootstrap の JavaScript.
//import { Tooltip, Toast, Popover } from 'bootstrap';
//import Alert from 'bootstrap/js/dist/alert';
//
//console.log([Tooltip, Toast, Popover]);

const Data = js_data; // eslint-disable-line no-undef
if (!('Messages' in Data)) {
    Data.Messages = {
      Block: {
        Search: '検索中です...',
        Save: '保存中です...',
        Delete: '削除中です...'
      },
      Error: {
          SystemError: '予期せぬエラーが発生しました。管理者にお問い合わせください。'
      }
    };
    Data.WebApi = {
        BaseUrl: Data.BaseUrl + 'api/',
    };
    Data.Interval = {
        Alert: {
            Close: 5000,
        }
    };
    deepFreeze(Data);
}
export {Data}; // eslint-disable-line no-undef
//console.log(js_data);// eslint-disable-line no-undef

/**
 * 再帰的にObject.freezeする関数
 * @param {object} o 対象オブジェクト
 * @returns {object} freezeしたオブジェクト
 */
function deepFreeze (o){ // eslint-disable-line no-unused-vars
    var prop, propKey;
    Object.seal(o);
    Object.freeze(o);
    for (propKey in o) {
        prop = o[propKey];
//    if (o.hasOwnProperty(propKey) && prop instanceof Object && !Object.isFrozen(prop)) {
//      deepFreeze(prop);
//    }
        if (o && Object.prototype.hasOwnProperty.call(o, propKey)
                && prop instanceof Object && !Object.isFrozen(prop)) {
            deepFreeze(prop); // eslint-disable-line no-unused-vars
        }
    }
}

///**
// * jQuery拡張
// * val()かtext()に val をセットする
// * @type object セットする値
// */
//jQuery.fn.extend({
//    valortext: function(val){
//        this.each(function(){
//            if ('value' in this) {
//                this.value = val;
//            } else {
//                this.textContent = val;
//            }
//        });
//    },
//});
